import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import config from "config"
import { selectNodeFilter, selectSensorStatusFilter } from "actions/sensorsettings"
import { downloadCSV } from "actions/stats"
import WidgetExport from 'components/common/dropdowncomponents/dataexportdropdown/widgetexport';
// This component is used in components/pages/overview/widgets/widget.jsx
import Modal from "components/common/modal"
import EditWidgetModalContent from 'components/common/widgets/locationbottommenu/editwidgetmodalcontent';

class LocationBottomMenu extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            isShowingSetting: false
        };
    }
    openSettingDropdown() {
        this.setState({ isShowingSetting: true });
    }

    closeSettingDropdown() {
        this.setState({ isShowingSetting: false });
    }

    deleteWidget(node) {
        this.props.deleteWidget(node.id);
    }

    render() {
        return (
            <div className="row widget-card__bottom-menu">
                {this.props.isComparisonWidget ?
                    <div className="col-xs-2"></div>
                    :
                    <div className="col-xs-4">
                        <div data-tooltip={"Widget settings"} onClick={this.openSettingDropdown.bind(this)} className="cursor--pointer widget-setting" >
                            <span className="font-icon icon-widgetsetting" />
                        </div >
                        {this.state.isShowingSetting && (
                            <div>
                                <div style={{ backgroundColor: 'transparent' }} className={"modals__overlay" + (this.state.isShowingSetting ? "" : " closed")} onClick={this.closeSettingDropdown.bind(this)} ></div>
                                <div className={"edit-widget-dropdown " + (this.state.isShowingSetting ? "" : " closed")}>
                                    <ul>
                                        <li onClick={() => {
                                            this.closeSettingDropdown();
                                            this.delWidgetModal.open();
                                        }} className="edit-widget-dropdown--item cursor--pointer">
                                            Delete
                                         </li>
                                        <li onClick={() => {
                                            this.closeSettingDropdown();
                                            this.editWidgetModal.open();
                                        }} className="edit-widget-dropdown--item cursor--pointer">
                                            Edit
                                        </li>

                                    </ul>
                                </div>
                            </div>)
                        }
                        <Modal
                            ref={(elem) => { this.delWidgetModal = elem }}
                            clickButton={() => { this.deleteWidget(this.props.node); this.delWidgetModal.close() }}
                            header="Delete Widget"
                            buttonText="Delete"
                            buttonClass="btn-danger"
                        >
                            <p>Are you sure you want to delete {this.props.node.info.name} ?</p>
                        </Modal>

                        <Modal
                            ref={(elem) => { this.editWidgetModal = elem }}
                            clickButton={() => { (this.editWidgetModalContent.submit() && this.editWidgetModal.close()) }}
                            header="Edit Widget"
                            buttonText="Confirm"
                            buttonClass="btn-success"
                        >
                            <EditWidgetModalContent
                                onRef={ref => (this.editWidgetModalContent = ref)}
                                tree={this.props.tree}
                                widgetLocations={this.props.user.details.location}
                                nodeId={this.props.node.id}
                                editWidget={this.props.editWidget}
                            />
                        </Modal>
                    </div>
                }
                <div className="col-xs-4" >
                    <WidgetExport node={this.props.node} widget={this.props.widget} downloadCSV={() => downloadCSV(this.props.node, this.props.querySettings)} />
                </div>
                <div className="col-xs-4">
                    <Link
                        data-tooltip={"Maintenance settings"}
                        to={(this.props.node.info.hasfloorplan && this.props.faulty) ? `/live/${this.props.node.id}` : "/settings/sensor"}
                        className="widget-setting"
                        onClick={() => {
                            if (this.props.node.info.hasfloorplan && this.props.faulty) { // live view
                                this.props.redirectMaintenanceView(this.props.node);
                            } else { // sensor settings
                                this.props.dispatch(selectNodeFilter(this.props.node));
                                // Filter : No fault sensor => all sensors, else offline sensor
                                var statusFilter = config.sensorStatusFilter[(this.props.faulty == 0) ? 0 : 2]
                                this.props.dispatch(selectSensorStatusFilter(statusFilter));
                            }
                        }}
                    >
                        {(this.props.faulty > 0) &&
                            <div className={"widget-setting__faulty-number " + (this.props.node.info.hasfloorplan ? "background--red" : "background--brown")}>
                                {this.props.faulty}
                            </div>
                        }
                        <span className="font-icon icon-maintenance" />
                    </Link>
                </div>

            </div>

        );
    }
}

function mapStateToProps(state) {
    return {
        querySettings: state.querySettingsReducer,
        token: state.authReducer.token,
        cards: state.defaultSettingsReducer.card,
        user: state.myAccountReducer.user
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(LocationBottomMenu);



// WEBPACK FOOTER //
// ./src/components/common/widgets/locationbottommenu/index.jsx